<template>
    <div class="card mb-4">
        <div class="card-header">
            <div class="row">
                <div class="col-6">
                    <h3 class="pull-left">
                        <strong>{{ trans.get('checkout.payment') }}</strong>
                    </h3>
                </div>
                <div class="col-6">
                    <div class="text-right">
                        <i>
                            <small>{{ trans.get('checkout.choose_your_payment_method') }}</small>
                        </i>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <tab v-for="payment_method in paymentMethods"
                 v-on="$listeners"
                 :componentName="payment_method.key"
                 :id="payment_method.id"
                 :name="payment_method.website_name"
                 :publicKey="payment_method.pivot.public_key"
                 :key="payment_method.key"
                 :selected="true">
            </tab>
        </div>
    </div>
</template>

<script>
import Tab from './Tab';
import {mapFields} from "vuex-map-fields";

export default {
  name: 'payment-methods',
  components: {
    Tab
  },
  computed: {
    ...mapFields([
      'paymentMethods',
    ]),
    isValid() {
      let isValid = false;
      this.$children.map(function (component) {
        if (component.isActive) {
          isValid = component.$children[0].isValid;
        }
      })
      return isValid;
    }
  },
};
</script>

<style scoped>
    .main-block {
        border: 1px solid #e4e4e4;
        border-radius: 3px;
        padding: 11px;
    }
</style>
